module.exports = __webpack_public_path__ + "img/zizhi8.a5f55016.jpg";